import React from 'react';
import './TargetLanding.css';
import image1 from "../../assets/features.png";
import image2 from "../../assets/tools.png";
import Contact from '../contact/Contact'; // ✅ adjust path as needed

const TargetApp = () => {
  return (
    <main className="target-landing section">
      <div className="container">
        <h1 className="section__title">Target App</h1>

        <p> <strong>Target,</strong> built to simplify and elevate GATE preparation for aspirants across India. The app is packed with powerful features that help students stay organized, focused, and motivated throughout their journey.</p>

        <p>The design focuses on <strong>minimalism, accessibility, and clarity,</strong> ensuring users have an intuitive experience while staying on top of their preparation.</p>

        <div className='target-image-container'>
          <img className="target-image" src={image1} alt="Target App Wireframe" />
        </div>

        <p>This wireframe was designed in <strong>Figma</strong> to lay the groundwork for a clean, user-friendly interface.</p>

        <h3>Key Features of the App:</h3>
        <ul className="target-features">
          <li><strong>Lecture & Test Planner:</strong> Structured daily schedules to keep users on track.</li>
          <li><strong>Progress Tracker:</strong> Visual dashboards showing subjects completed and tests attempted.</li>
          <li><strong>Daily Motivation:</strong> Inspirational quotes to keep the prep energy high.</li>
          <li><strong>Subject-Wise Lectures:</strong> Access to categorized video content for each GATE subject.</li>
          <li><strong>Test Series Integration</strong>: Real exam simulations to practice under time pressure.</li>
        </ul>

        <div className='target-image-container'>
          <img className="target-image" src={image2} alt="Target App Tools" />
        </div>

        <h3>Tools Used:</h3>
        <ul className="target-features">
          <li>Figma (UI/UX Design)</li>
          <li>React Native (App Development)</li>
          <li>Javascript (App Development)</li>
          <li>Node js (App Development)</li>
          <li>Firebase (Backend)</li>
          <li>Github</li>
        </ul>

        <h3>Available Now on Play Store</h3>
        <p>
          <a
            href="https://play.google.com/store/apps/details?id=com.targetsahgal&pcampaignid=web_share"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
              alt="Get it on Google Play"
              style={{ height: '60px' }}
            />
          </a>

        </p>



        <section className="target-cta">
          <h3>Hire Me to Elevate Your Brand</h3>
          <p>
            If you’re looking to transform <strong>your website</strong> and create designs that leave a lasting impression, I’m here to deliver exceptional results. Let’s <strong>collaborate</strong> to bring your vision to life!
          </p>
        </section>

        {/* ✅ Contact Form Directly Rendered Below */}
        <div style={{ marginTop: '40px' }}>
          <Contact />
        </div>
      </div>
    </main>
  );
};

export default TargetApp;
